export default function AuthenticationError(payload, message) {
  this.name = 'AuthenticationError';
  this.message = message;
  this.error = payload; // Legacy
  this.errors = payload;
  this.stack = (new Error()).stack;
}
AuthenticationError.prototype = new Error();
